import { guarantees } from "@/mocks/home";

const toneStyles = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-700",
];

export default function GuaranteesSection() {
  return (
    <section id="guarantees" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl mb-12">
          <p className="text-xs tracking-[0.25em] uppercase text-primary-600 mb-3">三重保障</p>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            为什么选择爆料51提交信息
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            我们把「保护投稿人」放在处理流程的第一步。匿名不是一句口号，而是从提交、流转到使用都贯穿的规则。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {guarantees.map((item, index) => (
            <article
              key={item.title}
              className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-7 flex flex-col"
            >
              <span
                className={`w-12 h-12 flex items-center justify-center rounded-lg mb-5 ${toneStyles[index % toneStyles.length]}`}
              >
                <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-3">{item.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}